import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShimmeruiComponent } from './shimmerui/shimmerui.component';
import { SpinnerLoaderComponent } from './spinner-loader/spinner-loader.component';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ShimmerMultilineLoaderComponent } from './shimmer-multiline-loader/shimmer-multiline-loader.component';




@NgModule({
  declarations: [
    ShimmeruiComponent,
    SpinnerLoaderComponent,
    ShimmerMultilineLoaderComponent
  ],
  exports: [ShimmeruiComponent,SpinnerLoaderComponent,ShimmerMultilineLoaderComponent],
  imports: [
    CommonModule,
    MatProgressSpinnerModule
    
  ]
})
export class ShimmerModule { }
